var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty } from '@syncfusion/ej2-base';
/**
 * A collection of JSON objects where each object represents a layer.
 * Layer is a named category of diagram shapes.
 */
export class LayoutInfo extends ChildProperty {
}
__decorate([
    Property('Horizontal')
], LayoutInfo.prototype, "orientation", void 0);
__decorate([
    Property('Center')
], LayoutInfo.prototype, "type", void 0);
__decorate([
    Property(undefined)
], LayoutInfo.prototype, "offset", void 0);
__decorate([
    Property(false)
], LayoutInfo.prototype, "enableRouting", void 0);
__decorate([
    Property([])
], LayoutInfo.prototype, "children", void 0);
__decorate([
    Property('')
], LayoutInfo.prototype, "assistants", void 0);
__decorate([
    Property('')
], LayoutInfo.prototype, "level", void 0);
__decorate([
    Property('')
], LayoutInfo.prototype, "hasSubTree", void 0);
__decorate([
    Property('')
], LayoutInfo.prototype, "rows", void 0);
